export default __webpack_public_path__ + "static/media/pac.2a995465.svg";